import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import OrderForm from './OrderForm';
import { useActionDispatcher } from '../../hooks';
import {
  getOrderRequest,
  resetCurrentOrder,
  saveOrderRequest,
} from '../../store/modules/orders/actions';
import { selectOrder } from '../../store/modules/orders/selectors';

const OrderEdit = () => {
  const dispatch = useDispatch();

  const order = useSelector(selectOrder);

  const match = useRouteMatch<{ id: string }>()!;

  const orderId = order.data?.id;

  useEffect(() => {
    const matchId = parseInt(match.params.id, 10);
    if (!orderId || matchId !== orderId) {
      dispatch(getOrderRequest(matchId));
    }
  }, [dispatch, match.params.id, orderId]);

  useEffect(() => () => {
    dispatch(resetCurrentOrder());
  }, [dispatch]);

  const saveOrder = useActionDispatcher(saveOrderRequest);

  return (
    <OrderForm
      record={order}
      onSubmit={saveOrder}
    />
  );
};

export default OrderEdit;
